/**
 * Final grades historically round upward. Normalize through the score columns'
 * four decimal places first so float noise cannot turn 0.14 into 15%.
 */
export function toFinalScorePercent(fraction: number): number
export function toFinalScorePercent(fraction: null): null
export function toFinalScorePercent(fraction: number | null): number | null
export function toFinalScorePercent(fraction: number | null) {
  return fraction === null
    ? null
    : Math.ceil(Math.round(fraction * 10_000) / 100)
}
